import React, { useState, useEffect, useRef } from "react";
import styles from "./industry.module.scss";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import Button from "components/button";
import { fetchCompany, fetchStakeholders } from "actions/meeting";
import { EmptyMessage } from "../../../../components/emptyMessage";
import { trackAdoptionMetricsForLearnMoreClickedEvent } from "actions/adoption";
import Truncate from "react-truncate";

export default function Industry({ handleClick }) {
  const dispatch = useDispatch();

  const meetingAttendees = useSelector(
    (state) => _.get(state, "selection.meetingDetails.attendeeIds") || {}
  );
  const loadingCompanies = useSelector(
    (state) => _.get(state, "meeting.loadingCompanies") || false
  );

  const companies = useSelector(
    (state) => _.get(state, "meeting.companies") || []
  );

  const loadingStakeholders = useSelector(
    (state) => _.get(state, "meeting.loadingStakeholders") || false
  );

  const stakeholders = useSelector(
    (state) => _.get(state, "meeting.stakeholders") || []
  );

  const user = useSelector((state) => _.get(state, "users.profile.item")) || {};

  const userId =
    useSelector((state) => _.get(state, "users.profile.item.id")) || "";

  const deals = useSelector(
    (state) => _.get(state, "meeting.deals") || []
  );

  const loadingDeals = useSelector(
    (state) => _.get(state, "meeting.fetchingDeals") || false
  );

  useEffect(() => {
    if (_.size(meetingAttendees) > 0 && userId) {

     const userEmailDomain = user.email ? user.email.split("@")[1] : null;

      const filteredEmails = meetingAttendees.filter((email) => {
        const parts = email.split("@");
        const domain = parts.length > 1 ? parts[1] : null;
        return domain !== userEmailDomain;
      });

      dispatch(
        fetchCompany({
          emails: _.map(filteredEmails, (attendee) => attendee),
        })
      );
      dispatch(
        fetchStakeholders({
          emails: _.map(filteredEmails, (attendee) => attendee),
        })
      );
    }
  }, [meetingAttendees, userId]);
  return (
    <>
      <div className={styles.header}>
        <i className="paperflite-industry" />
        Industry & Key stakeholders
      </div>

      {loadingDeals || loadingCompanies ? (
        <div className={styles.placeholderContainer}>
          <div className={styles.placeholderCompany} />
          <div className={styles.placeholderStakeholder} />
        </div>
      ) : (
        <div className={styles.contentContainer}>
          <div className={styles.detailRow}>
            <div className={styles.detailName}>/ {_.get(companies,"[0].name","Company")}</div>
            <div className={styles.detailValue}>
              {_.size(deals) > 0 && _.size(companies) > 0 ? (
                 <div key={companies[0].name}>
                  <Truncate lines={2} className={styles.companyInfo}>
                    {_.get(companies[0], "summary", "N/A")}
                  </Truncate>
                 </div>
              ) : (
                <EmptyMessage
                  src="/images/meeting/no_company.png"
                  message="No company information"
                />
              )}
            </div>
          </div>
        </div>
      )}

      {loadingDeals || loadingStakeholders ? (
        <div className={styles.placeholderContainer}>
          <div className={styles.placeholderCompany} />
          <div className={styles.placeholderStakeholder} />
        </div>
      ) : (
        <div className={styles.contentContainer}>
        <div className={styles.detailRow}>
          <div className={styles.detailName}>/ Stakeholders</div>
          <div className={styles.detailValue}>
            {_.size(deals) > 0 && _.size(stakeholders) > 0 ? (
                <div key={stakeholders[0].name}>
                  <div className={styles.stakeholderInfo}>
                  <Truncate lines={2} className={styles.companyInfo}>
                    {_.get(stakeholders[0], "summary", "N/A")}
                  </Truncate>
                  </div>
                </div>
            ) : (
              <EmptyMessage
                src="/images/meeting/no_stakeholders.png"
                message="No prospect information"
              />
            )}
          </div>
          </div>
        </div>
      )}
      {!loadingCompanies && !loadingDeals && (_.size(companies)> 0 || _.size(stakeholders) > 0) && (
        <Button
          text="View more"
          icon="paperflite-right-arrow"
          className={styles.button}
          handleButtonClick={() => handleClick("industry")}
        />
      )}
    </>
  );
}

export function IndustryDetails({}) {

  const dispatch = useDispatch();

  const companies = useSelector(
    (state) => _.get(state, "meeting.companies") || []
  );

  const stakeholders = useSelector(
    (state) => _.get(state, "meeting.stakeholders") || []
  );

  const DETAILS = [
    {
      name: _.get(companies,"[0].name","company"),
      value: _.size(companies) > 0 ? (
        <div key={companies[0].name} className={styles.companyContainer}>
          <Details title="" value={companies[0].summary || "N/A"} />
          <Details title="Industry" value={companies[0].industry || "N/A"} />
          <Details title="Number of Employees" value={companies[0].employeeCount || "N/A"} />
          <Details title="Recent Highlights" value={companies[0].recentHighlights || "N/A"} />
        </div>
      ) : null,
    },
    {
      name: "Stakeholders",
      value: (
        <div className={styles.stakeholderTabsContainer}>
          {_.size(stakeholders) > 0 ? (
            <StakeholderTabs stakeholders={stakeholders} />
          ) : (
            <EmptyMessage
              src="/images/meeting/no_stakeholders.png"
              message="No prospect information"
            />
          )}
        </div>
      ),
    },
  ];

  if (_.size(companies) === 0) {
    DETAILS.splice(DETAILS.findIndex((detail) => detail.name === "company"), 1);
  }

  if (_.size(stakeholders) === 0) {
    DETAILS.splice(DETAILS.findIndex((detail) => detail.name === "prospect info"), 1);
    }

  useEffect(() => {
    dispatch(trackAdoptionMetricsForLearnMoreClickedEvent("Learn More Clicked", "Industry"));
  }, []);

  const [activeTab, setActiveTab] = useState(_.get(DETAILS[0], "name") || "");

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  const activeDetail = DETAILS.find((detail) => detail.name === activeTab);

  return (
    <div className={styles.detailsContainer}>
      <div className={styles.tabHeader}>
        {DETAILS.map((detail) => (
          <div
            key={detail.name}
            className={`${styles.tab} ${
              activeTab === detail.name ? styles.activeTab : ""
            }`}
            onClick={() => handleTabClick(detail.name)}
          >
            {detail.name}
          </div>
        ))}
      </div>

      <div className={styles.tabContent}>
        {activeDetail?.value}
        <div className={styles.poweredBy}>powered by Perplexity</div>
      </div>
    </div>
  )
}

function StakeholderTabs({ stakeholders }) {
  const [activeStakeholder, setActiveStakeholder] = useState(
    stakeholders[0]?.name
  );

  const tabRefs = useRef({});

  const activeDetail = stakeholders.find(
    (s) => s.name === activeStakeholder
  );

  const handleTabClick = (stakeholderName) => {
    setActiveStakeholder(stakeholderName);
    
    if (tabRefs.current[stakeholderName]) {
      tabRefs.current[stakeholderName].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }
  };

  return (
    <div className={styles.stakeholderContainer}>
      <div className={styles.subTabHeader}>
        {stakeholders.map((stakeholder) => (
          <div
            key={stakeholder.name}
            className={`${styles.subTab} ${
              activeStakeholder === stakeholder.name ? styles.activeSubTab : ""
            }`}
            onClick={() => handleTabClick(stakeholder.name)}
            ref={(element) => (tabRefs.current[stakeholder.name] = element)}
          >
            {stakeholder.name}
          </div>
        ))}
      </div>

      <div className={styles.subTabContent}>
        {activeDetail && (
          <div className={styles.detailItem}>
            <div className={styles.summary}>
              {_.get(activeDetail, "summary", "N/A")}
            </div>
            <div className={styles.designation}>
              <span className={styles.header}>Designation</span>
              <span className={styles.subText}>{_.get(activeDetail, "designation", "N/A")}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const Details = ({title, value}) => (
  <div className={styles.detailsContainer}>
    <div className={styles.title}>{title}</div>
    <div className={styles.value}>{value}</div>
  </div>
);